import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextMaskModule } from 'angular2-text-mask';

import { OverlayModule } from '@angular/cdk/overlay';

import { DatepickerComponent } from './datepicker.component';
import { DatepickerInputDirective } from './datepicker-input/datepicker-input.directive';
import { DatepickerInputMaskDirective } from './datepicker-input/datepicker-input-mask.directive';

import { CalendarComponent } from './calendar/calendar.component';
import { CalendarService } from './calendar/calendar.service';
import { DatepickerCalendarComponent } from './datepicker-calendar/datepicker-calendar.component';
import { DatepickerValidatorService } from './datepicker-validator.service';
import { FormsModule } from '@angular/forms';

import { PopoverModule } from './popover/popover.module';
import { OverlayService } from './shared/overlay.service';
import { UtilService } from './shared/util.service';

@NgModule({
  imports: [
    CommonModule,
    TextMaskModule,
    OverlayModule,
    FormsModule,
    PopoverModule
  ],
  declarations: [
    DatepickerComponent,
    DatepickerInputDirective,
    DatepickerInputMaskDirective,
    DatepickerCalendarComponent,
    CalendarComponent
  ],
  entryComponents: [DatepickerCalendarComponent],
  exports: [DatepickerComponent, DatepickerInputDirective, DatepickerInputMaskDirective, CalendarComponent],
  providers: [CalendarService, DatepickerValidatorService, OverlayService, UtilService]
})
export class DatepickerModule { }



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/datepicker.module.ts